module.exports = __webpack_public_path__ + "img/Diagram V2.b67b6905.jpg";